var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:[
    _vm.fullscreen ? 'loader-overlay' : 'loader-inline',
    _vm.darkMode ? 'dark' : ''
  ]},[_c('div',{staticClass:"loader-box"},[(_vm.lottieUrl)?_c('lottie-player',{staticStyle:{"width":"120px","height":"120px"},attrs:{"src":_vm.lottieUrl,"background":"transparent","speed":"1","loop":"","autoplay":""}}):_c('div',{staticClass:"spinner"}),(_vm.message)?_c('p',{staticClass:"loader-message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }